import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { RegisterStudent } from '~pages/student/register-student';

const parentSchema = z.object({
  parentId: z.string().min(4),
});

export const Route = createFileRoute('/_auth/register-student')({
  validateSearch: zodValidator(parentSchema),
  component: RegisterStudent,
});
